import messages from '@src/common/messages.json';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';

export const updateTermsOfUseError = (res) => {
  const data = res.data || {};
  const statusCode = res.status;
  const { faultCode } = data;
  const { duration, endpoint, message } = res;
  const errorData = {
    status: faultCode,
    message,
    code: statusCode,
    duration,
    endpoint,
  };
  eapmEvent('EAPM_TRANSACTION_ERROR', errorData);

  if (res.status === 500) {
    throw {
      statusCode,
      faultCode,
      message: messages.TIN_SUBMISSION_FAILED,
    };
  }

  throw res;
};

export const validationTermsError = (res) => {
  const data = res.data || {};
  const statusCode = res.status;
  const { faultCode } = data;
  const { duration, endpoint, message } = res;
  const errorData = {
    status: faultCode,
    message,
    code: statusCode,
    duration,
    endpoint,
  };
  eapmEvent('EAPM_TRANSACTION_ERROR', errorData);

  if (res.status !== 400) {
    throw {
      statusCode: 500,
      faultCode,
      message: messages.BILLING_TIN,
    };
  }

  throw res;
};
